import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  // Stores an item, automatically stringifying objects
  setItem(key: string, value: any): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error saving to session storage', error);
    }
  }

  // Retrieves an item, automatically parsing JSON
  getItem(key: string): any {
    try {
      const storedValue = sessionStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error('Error getting from session storage', error);
      return null;
    }
  }

  // Removes an item
  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  // Clears all session storage
  clear(): void {
    sessionStorage.clear();
  }
}